/**
 * Jungle Calling — top announcement promo ticker.
 *
 * The announcement bar keeps its theme section; this script only enhances it
 * when the merchant writes two or more promo links in the message field, so
 * there is nothing to configure and no change for single-message bars.
 */
(function () {
  var TICKER_CLASS = 'jc-promo-ticker';
  var TRACK_HTML = function (html) {
    return (
      '<span class="jc-promo-ticker__track">' +
      '<span class="jc-promo-ticker__group">' + html + '</span>' +
      '<span class="jc-promo-ticker__group" aria-hidden="true">' + html + '</span>' +
      '</span>'
    );
  };

  function initTicker(section) {
    var scope = section || document;
    var messages = scope.querySelectorAll('.announcement-bar__text p');

    Array.prototype.forEach.call(messages, function (message) {
      if (message.dataset.jcPromoTicker === 'true') return;

      var links = message.querySelectorAll('a');
      if (links.length < 2) return;

      var html = message.innerHTML.trim();
      if (!html) return;

      message.innerHTML = TRACK_HTML(html);
      message.classList.add(TICKER_CLASS);
      message.dataset.jcPromoTicker = 'true';
    });
  }

  function boot() {
    initTicker(document.querySelector('.section-announcement') || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTicker(event.target);
  });
})();
